import { CloseOutline24Icon } from "@vygruppen/spor-icon-react";
import { VehicleCancellationModal } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/Itinerary/VehicleCancellation/VehicleCancellationModal";
import { isShuttleVehicle } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/utils";
import { FC, useState } from "react";
import { DropsButton } from "shared/components/Spor";
import {
  AlternativeTransportVehicle,
  StopReference,
} from "shared/types/alternativeTransport";

export const getValueFromStopRef = (stopRef: StopReference) =>
  stopRef.nsrCode ??
  stopRef.nsrStopPlace ??
  stopRef.hastusCode ??
  stopRef.jbvId ??
  stopRef.uicCode ??
  "";

export type CancellationProps = {
  vehicle: AlternativeTransportVehicle;
};

export const VehicleCancellation: FC<CancellationProps> = ({ vehicle }) => {
  const { itinerary } = vehicle;
  const [showModal, setShowModal] = useState(false);
  const firstStopId = itinerary
    ? getValueFromStopRef(itinerary.stops[0].stopReference)
    : null;
  const lastStopId = itinerary
    ? getValueFromStopRef(
        itinerary.stops[itinerary.stops.length - 1].stopReference,
      )
    : null;

  /* Do not show cancellation option when empty itinerary
   * or when vehicle is an operational shuttle vehicle
   * or when vehicle is already fully cancelled
   */
  if (
    !itinerary ||
    itinerary.stops.length === 0 ||
    isShuttleVehicle(vehicle) ||
    vehicle.vehicleStatus === "CANCELLED" ||
    firstStopId === null ||
    lastStopId === null
  ) {
    return null;
  }

  return (
    <>
      <DropsButton
        variant="ghost"
        size="sm"
        leftIcon={<CloseOutline24Icon />}
        onClick={() => setShowModal(true)}
      >
        Kanseller
      </DropsButton>
      {showModal && (
        <VehicleCancellationModal
          vehicle={vehicle}
          itineraryStops={itinerary.stops}
          firstStopId={firstStopId}
          lastStopId={lastStopId}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};
